import { render } from "./optIn.vue?vue&type=template&id=09902114&scoped=true"
import script from "./optIn.vue?vue&type=script&lang=js"
export * from "./optIn.vue?vue&type=script&lang=js"

import "./optIn.vue?vue&type=style&index=0&id=09902114&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09902114"]])

export default __exports__